import {createStore} from "redux";
import {syncHistoryWithStore} from 'react-router-redux';
import {hashHistory } from 'react-router';

import rootReducer from "./reducers/index";

import {storageName} from "./components/baseFunctions";

const defaultState = {
      data: {
        lang: window.navigator.language.toLocaleLowerCase().includes("dk") ? "DK" : "EN",
        logo: "",
        justLogged: true,
        modules: [],
        groups: [],
        auth: false,
        userInfo: {
        	name: "",
        	rank: "",
          firm: "",
          id: 0
        },
        otherDepartments: [],
        cachedAPIs: [],
      }
 };

var persistedState = localStorage.getItem(storageName) ? JSON.parse(localStorage.getItem(storageName)) : defaultState;
//persistedState = persistedState.version < defaultState.version ? defaultState : persistedState;
const store = createStore(rootReducer, persistedState);

store.subscribe(()=>{
  localStorage.setItem(storageName, JSON.stringify(store.getState()))
});

export const history = syncHistoryWithStore(hashHistory, store);

history.listen((location) => {
    if(window.ga)
    {
      let path = "/" + document.URL.split("/#/")[1];//document.URL.split("/").filter((d,k) => k > 2).join("/");
      console.log("Navigating to", path);
      window.ga('set', 'page', path);
      window.ga('send', 'pageview');
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store.js